// shared by the dropzone upload and the mobile (QR) photo handoff,
// so both paths put the photo into the popup exactly the same way
export const applyLookAiUserFile = (file, lookAiPopupDispatch, setAiUserFileBlobUrl) => {
  if (!file) {
    return
  }
  const userFileBlobUrl = URL.createObjectURL(file);
  lookAiPopupDispatch({
    userFile: file,
    userFileBlobUrl,
    showSourceChooser: false,
  });
  setAiUserFileBlobUrl(userFileBlobUrl);
};
